import { render, staticRenderFns } from "./otherFees.vue?vue&type=template&id=57cb84c4&scoped=true&"
import script from "./otherFees.vue?vue&type=script&lang=js&"
export * from "./otherFees.vue?vue&type=script&lang=js&"
import style0 from "./otherFees.vue?vue&type=style&index=0&id=57cb84c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cb84c4",
  null
  
)

export default component.exports